module.exports = __webpack_public_path__ + "static/media/anatomia.412f8fc3.png";